import { ReactNode } from 'react';

const InstructionalForm = ({
  form,
  instructions,
}: {
  form?: ReactNode;
  instructions?: ReactNode;
}) => (
  <div className="instructional-form">
    {form}
    <div className="instructional-form__instructions">{instructions}</div>
  </div>
);

export default InstructionalForm;
